<template>
	<div>
		<div class="row">
			<div class="col-xs-12 topic-header dash-bg-color-skin-light-40">
				<p>{{ knowledge.title }}</p>
			</div>
		</div>

		<div class="row">
			<div class="col-xs-12 detail-knowledge">{{ knowledge.content }}</div>	
	   </div>
		
		<div class="row attachment">
			<div class="col-xs-2 att-ico">
				<a :href="knowledge.file_path" download class="fa fa-paperclip dash-color-skin" aria-hidden="true" v-show="knowledge.file_path"></a>
			</div>

			<div class="col-xs-2 att-ico">
				<a  :href="'http://' + knowledge.link" target="_blank" class="fa fa-link dash-color-skin" aria-hidden="true" v-show="knowledge.link"></a>
			</div>

			<div class="col-xs-8">
				<div class="row writer">
					<div class="col-xs-2 ico">
						<i class="fa fa-user-o" aria-hidden="true"></i>
					</div>
					<div class="col-xs-10 text">
						{{ knowledge.coduser }} 
					</div>
				</div>
				<div class="row writer">
					<div class="col-xs-2 ico">
						<i class="fa fa-calendar-check-o" aria-hidden="true"></i>
					</div> 
					<div class="col-xs-6 text">
						{{ knowledge.dteupd }} 
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
  name: 'knowledge-detail',
  props: [ 'knowledge' ]
}
</script>


// WEBPACK FOOTER //
// detail.vue?934f8270